import axios from "axios";
import { API_BASE_URL } from "../../constants/index";
import { setupAuthInterceptor } from "./interceptors/auth";
import { setupErrorInterceptor } from "./interceptors/error";
import { setupLoggingInterceptor } from "./interceptors/logging";

/**
 * Cliente Axios configurado para a API do LicitarsAI
 * 
 * Configurações:
 * - Base URL configurada
 * - Timeout de 30 segundos
 * - Credenciais incluídas
 * - Interceptors para auth, erro e logging
 */
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
  withCredentials: true,
});

// Configurar interceptors
setupAuthInterceptor(apiClient);
setupErrorInterceptor(apiClient);
setupLoggingInterceptor(apiClient);

export default apiClient; 